import $api from "../../../http";

export const userConfirm = async (token) => {
  return await $api.get(`user/confirm?token=${token}`);
};
